/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Button, Form} from "react-bootstrap";


type DefaultFormButtonProps = {
    buttonText: string;
    clickHandler(): any;
    disabled?: boolean;
    controlId?: string;
    cssClasses?: string;
    size?: "lg" | "sm" | undefined;
    variant?: string
};


export const DefaultFormButton: React.FC<DefaultFormButtonProps> = ({
    buttonText, clickHandler,
    disabled = false,
    controlId = "", cssClasses = "", size = "lg", variant = "primary"
}): JSX.Element => {


    cssClasses = (cssClasses ? `${cssClasses} ` : "") + "user-form-button-container text-center";


    return (
        <Form.Group controlId={controlId} className={cssClasses}>
            <Button disabled={disabled} variant={variant} size={size} onClick={clickHandler}>
                <span>{buttonText}</span>
            </Button>
        </Form.Group>
    );

};


export default DefaultFormButton;
